import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('product-templates', storeModule.createStoreModule('product-templates'))
